var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"land"}},[_c('f7-navbar',{attrs:{"title":"Land"}}),_vm._v(" "),_c('f7-block',[_c('h1',{staticClass:"brow_title"},[_vm._v("This is Land page")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }